import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { LibrariesRouteNames, LibrariesRoutePathNames } from '../../../../enums';

const Component = () => import('./CpgVerifiedItems.vue');

export default {
  path: buildChildURL(
    LibrariesRoutePathNames.CPG_ITEMS_LIST,
    LibrariesRoutePathNames.VERIFIED_ITEMS,
  ),
  name: LibrariesRouteNames.VERIFIED_ITEMS,
  component: Component,
} as RouteRecordRaw;
